<template>
  <div>
    <div class="flex-center-between">
      <div class="title">订单列表</div>
      <!-- <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15">发起签章</el-button> -->
      <div>
        <el-button size="small" type="primary" @click="openVisible('edit')">发票抬头管理</el-button>
      </div>
    </div>

    <div class="pt10">
      <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%">
        <el-table-column
            prop="tradeNo"
            label="订单编号"
            >
        </el-table-column>
        <el-table-column
            align="center"
            prop="productName"
            label="商品名称"
            >
        </el-table-column>
        <el-table-column
            align="center"
            prop="productPrice"
            label="商品价格"
            >
        </el-table-column>
        <el-table-column
            align="center"
            label="发票状态">
          <template slot-scope="scope" v-if=" scope.row.status == 1">
            <el-tag type="info" v-if="scope.row.invoiceStatus == 0" size="small" >未申请</el-tag>
            <el-tag v-if="scope.row.invoiceStatus == 1" size="small">申请中</el-tag>
            <el-tag type="success" v-if="scope.row.invoiceStatus == 2" size="small">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            label="订单状态"
            align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status == 0" size="small" >未处理</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1" size="small">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="payStatus"
            label="支付状态"
            align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.payStatus == '1'" size="small">已付款</el-tag>
            <el-tag type="danger" v-if="scope.row.payStatus == '0'" size="small" >未付款</el-tag>
            <el-tag v-if="scope.row.payStatus == '9'" size="small" >已退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            label="创建时间"
            align="center">
          <template slot-scope="scope">
            {{ $moment(scope.row.createTime).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="text" v-if="scope.row.invoiceStatus == 0 && scope.row.status == 1 && scope.row.payStatus == 1" @click="openVisible('add',scope.row)">开 票</el-button>

            <el-button size="mini" type="text" v-if="scope.row.invoiceStatus == 2 && scope.row.status == 1 && scope.row.payStatus == 1" @click="handleCheck(scope.row)">下 载</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <pagination
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getOnlineTradeInfo"

        />
      </div>
    </div>

    <invoice-header
      v-if="invoiceVisible"
      :visible.sync="invoiceVisible"
      :product="product"
      :type="type"
      @handleInvoicing="handleInvoicing"
    />

    <invoice-add
        v-if="invoiceAddVisible"
        :visible.sync="invoiceAddVisible"
        :product="product"
        :headerList="headerList"
        @refresh="refresh"
    />

    <invoice-img
        v-if="invoiceImgVisible"
        :visible.sync="invoiceImgVisible"
        :product="product"
    />
  </div>
</template>

<script>
import InvoiceHeader from "@/pages/userCenter/components/invoiceHeader.vue";
import InvoiceAdd from "@/pages/userCenter/components/invoiceAdd.vue";
import InvoiceImg from "@/pages/userCenter/components/invoiceImg.vue";
import {auth} from "@/utils/auth";
import axios from "axios";

export default {
  name: "MyOrder",
  components: {InvoiceImg, InvoiceAdd, InvoiceHeader},
  data() {
    return {
      loading: false,
      tableData: [],
      queryParams: {
        pageNum: 1,
        pageSize: 5,
      },
      total: 0,
      invoiceVisible: false,
      invoiceAddVisible: false,
      invoiceImgVisible: false,
      type: 'edit',
      product: {},
      headerList: {},
    };
  },
  created() {
    this.getOnlineTradeInfo()
  },
  methods:{
    handleCheck(row){
      // this.product = row
      // this.invoiceImgVisible = true
      let fileUrl = process.env.VUE_APP_API_BASE_URL + "/online/eseal/getInvoice/" + row.tradeNo
      let token = auth.getToken();
      axios({
        url: fileUrl,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token,
        },
        responseType: 'blob', // 设置响应类型为blob
      }).then(response => {
        const blob = new Blob([response.data]);
        const fileName = '发票.pdf';
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
      }).catch(err => {

      })
    },
    refresh(){
      this.invoiceAddVisible = false
      this.invoiceVisible = false
      this.product = {}
      this.headerList = {}
      this.getOnlineTradeInfo()
    },
    // 发票抬头管理
    openVisible(type,row){
      this.type = type
      this.product = row
      this.invoiceVisible = true
    },
    getOnlineTradeInfo(){
      this.loading = true
      this.$http.get(this.$api.user.onlineTradeInfo,this.queryParams).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.rows
          this.total = res.data.total
          this.loading = false
        }
      })
    },
    handleInvoicing(e){
      this.invoiceAddVisible = e.type
      this.headerList = e.list
    },
  }
}
</script>

<style lang="less" scoped>
.title-name {
  width: 125px;
}

.text-container {
  max-width: 250px; /* 或者其他需要的宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.custom-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  ::v-deep .el-button {
    padding: 0 ;
  }
}

.lock-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  .auth-label {
    background-color: #00cc69;
    border-radius: 9px 9px 9px 0;
    display: inline-block;
    font-weight: 300;
    color: #fff;
    font-style: normal;
    position: relative;
    padding: 0 5px;
    top: 0;
    font-size: 13px;
    margin-left: 20px;
  }

  .public-but {
    width: 60px;
    height: 24px;
    border: 1px solid #407fff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #407fff;
    line-height: 24px;
    text-align: center;
    margin: 0 0 0 25px;
    cursor: pointer;
    display: inline-block;
  }

  .public-warn {
    border: 1px solid #F56C6C;
    color: #F56C6C;
  }
}

::v-deep .el-tabs__item {
  height: 48px;
  line-height: 48px;
}

::v-deep .el-tabs__header {
  display: none
}

::v-deep .el-link--default {
  color: #2c3e50 ;
}
</style>
